import { alpha } from '@material-ui/core';
import { Color, ColorDynamic } from "../theme/Color.js";
export function overrideList(theme) {
  var color = theme.palette.type === 'dark' ? alpha(Color.White, 0.08) : ColorDynamic.Silver200;
  theme.overrides.MuiListItem = {
    root: {
      '&$selected, &$selected:hover': {
        backgroundColor: ColorDynamic.Blue50
      },
      '& .MuiTouchRipple-root': {
        color: ColorDynamic.Blue100
      }
    },
    button: {
      '&:hover': {
        backgroundColor: color
      }
    }
  };
}